import gql from 'graphql-tag';

const NAME = 'moveIqCompanyDetail';
const FRAGMENT = `fragment ${NAME} on MoveIqCompany {
  address {
    city
    postalCode
    state
    street
  }
  affiliations
  coverageAreas {
    city
    postalCode
    state
  }
  description
  email
  id
  licenses {
    dot
    interstate
    local
  }
  logo {
    base
    path
  }
  name
  noteworthy
  numberOfMoves
  numberOfTrucks
  phone
  rating {
    google
    qualityRating
    reviews {
      date
      name
      rating
      review
    }
  }
  services
  website
  yearOfEstablishment
}`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
